import type { LocalContact } from '@/context/create-account-flow';

/**
 * Merges Fiscal contacts that share the same name into a single contact
 * with all their contactItems combined. Non-Fiscal contacts are returned as-is.
 */
export function mergeFiscalContacts(contacts: LocalContact[]): LocalContact[] {
  const nonFiscal: LocalContact[] = [];
  const fiscalByName = new Map<string, LocalContact>();

  for (const contact of contacts) {
    const isFiscal = contact.contactFor?.includes('Fiscal');

    if (!isFiscal) {
      nonFiscal.push(contact);
      continue;
    }

    const key = (contact.name ?? '').trim();
    const existing = fiscalByName.get(key);

    if (existing) {
      // Merge contactItems, avoiding duplicates by contact value + type
      const existingKeys = new Set(
        existing.contactItems.map((item) => `${item.type}:${item.contact}`),
      );
      const newItems = contact.contactItems.filter(
        (item) => !existingKeys.has(`${item.type}:${item.contact}`),
      );
      existing.contactItems = [...existing.contactItems, ...newItems];
    } else {
      // Clone to avoid mutating the original
      fiscalByName.set(key, {
        ...contact,
        contactItems: [...contact.contactItems],
      });
    }
  }

  return [...fiscalByName.values(), ...nonFiscal];
}
